import { Routes } from '@angular/router';
import { FieldManagementMapComponent } from './field-management-map.component';
import { UserRouteAccessService } from '../shared/auth/user-route-access-service';

export const FIELD_MANAGEMENT_ROUTES: Routes = [
    {
        path: '',
        component: FieldManagementMapComponent,
        data: {
            authorities: ['ADMIN', 'FIELDMAP_MANAGER'],
            pageTitle: 'field-manager.title'
        },
        canActivate: [UserRouteAccessService],
    }
];
